import React from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getAgDetailsByBaseUrl } from "../../service/commonService";
import { getCodeFromUrl } from "../../utils/helper";

const AgDetail = () => {
  const agDetails = useSelector((state) => state.common.agDetails);
  const files = useSelector((state) => state.common.agDetails?.files || {});
  const codeFromUrl = getCodeFromUrl();

  useEffect(() => {
    getAgDetailsByBaseUrl(codeFromUrl);
  }, [codeFromUrl]);

  return (
    <div className="ag-layout">
      <div className="auth--img">
        <img src={files?.logo_media_id?.media_url} alt="logo" />
      </div>
      <h1 className="auth--title">{agDetails.name || "-"}</h1>
      <p className="auth--subtitle">
        Registration No. {agDetails.registration_number || "-"}
      </p>
    </div>
  );
};

export default AgDetail;
